import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { RecaptchaModule } from 'ng-recaptcha';
import { LoaderModule } from '../loader/loader.module';
import { LoginV2Component } from './login-v2/login-v2.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
@NgModule({
  declarations: [LoginComponent, LoginV2Component],
  imports: [CommonModule, LoginRoutingModule, ReactiveFormsModule, FormsModule, MatFormFieldModule, MatInputModule, RecaptchaModule, LoaderModule, MatDatepickerModule,  MatNativeDateModule, MatSelectModule, NgxIntlTelInputModule],
  providers: [{ provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } }]
})
export class LoginModule { }
